import { ActionButton, Paragraph, YStack } from '@my/ui'
import { ChevronLeft } from '@tamagui/lucide-icons-2'
import React from 'react'
import { SimplePlaidLink } from './simpleplaidlink'
import { useLink } from '@my/util'

export function DemoScreen() {
  const link = useLink('/')

  return (
    <YStack f={1} justifyContent="center" alignItems="center" space>
      <Paragraph ta="center" fow="700">{`Plaid:`}</Paragraph>
      <SimplePlaidLink />
      <ActionButton {...link} icon={ChevronLeft}>
        Go Home
      </ActionButton>
    </YStack>
  )
}
